[
  {
    "date": "2026-09-05",
    "title": "Character saves arrive",
    "body": "Your hero now persists between sessions. Progress is written automatically when you travel between zones and when you close the tab, and the main menu's Continue button picks up right where you left off — level, gear, gold, professions, and quest progress included."
  },
  {
    "date": "2026-09-05",
    "title": "The world opens: Hearthmere and beyond",
    "body": "The first slice of the overworld is live. Set out from the town of Hearthmere into the Ashtrail Expanse, descend into the Hollowdeep, and face Embercleft at the bottom. Pack hunts, an elite, a boss, a vendor, and your first quest await — with a minimap to keep you oriented."
  },
  {
    "date": "2026-09-04",
    "title": "Loot Divers enters the browser",
    "body": "The game now runs entirely in your browser — no download, no launcher. New divers wash ashore at Wakeshore Landing, a short tutorial cove that teaches movement, combat, dodging, looting, and gathering before the road to Hearthmere opens."
  }
]
